// Thin wrapper over Umami. Every call here is a no-op unless the script
// actually loaded: a missing website id, an ad blocker, or an offline visitor
// should cost a dropped metric and nothing else. Nothing in a CTA handler or a
// form submit is allowed to throw because analytics wasn't available.

const WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID;

// overridable so a self-hosted instance can be pointed at later without a code
// change — Umami Cloud is just the default host
const SCRIPT_SRC = process.env.REACT_APP_UMAMI_SRC || 'https://cloud.umami.is/script.js';

let injected = false;

// Injected from here rather than hardcoded into index.html so the tag is never
// emitted without an id at all. A tag carrying an empty data-website-id still
// fetches the script and then fails on every event it's handed.
//
// Umami's script auto-tracks pageviews and patches history.pushState itself, so
// the /founder route change is counted without any wiring on our side.
function initAnalytics() {
    if (injected || !WEBSITE_ID || typeof document === 'undefined') return;
    injected = true;

    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-website-id', WEBSITE_ID);

    document.head.appendChild(script);
}

// `data` is sent as event properties. Keep it to non-identifying values —
// nothing a visitor typed into the form belongs in here.
function track(event, data) {
    try {
        window.umami?.track(event, data);
    } catch {
        // blocked, not loaded yet, or the API moved — never worth interrupting
        // whatever the visitor was actually in the middle of doing
    }
}

export { initAnalytics, track };
